var map = {
	"./bg-1-emea.jpg": 58,
	"./bg-1-mobile-emea.jpg": 59,
	"./bg-1-mobile-ncsa.jpg": 60,
	"./bg-1-ncsa.jpg": 61,
	"./bg-1-tablet-emea.jpg": 62,
	"./bg-1-tablet-ncsa.jpg": 63,
	"./bg-emea.jpg": 64,
	"./bg-mobile-emea.jpg": 65,
	"./bg-mobile-ncsa.jpg": 66,
	"./bg-ncsa.jpg": 67,
	"./bg-tablet-emea.jpg": 68,
	"./bg-tablet-ncsa.jpg": 69
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16;